import React from 'react';

import cx from 'classnames';
import { connect } from 'react-redux';
import './ImpersonationSwitcher.scss';
import { actions } from 'coupon-common/src/modules/auth';

class ImpersonationSwitcher extends React.Component {
  state = { options: [], query: '', busy: false, error: null };
  timer = null;

  isVisible = (decoded = this.props.decoded) =>
    Boolean(decoded && (decoded.is_staff || decoded.impersonated_by));

    componentDidMount() {
    console.log('[ImpersonationSwitcher] mounted');
    if (this.isVisible()) this.load('');
  }

  componentDidUpdate(prevProps) {
    if (!this.isVisible(prevProps.decoded) && this.isVisible()) {
      this.load(this.state.query);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

    load = query =>
    new Promise(resolve => this.props.fetchOptions(query, resolve)).then(
      options => {
        console.log('[ImpersonationSwitcher] options loaded', options);
        this.setState({ options });
      },
    );

  onSearch = e => {
    const query = e.target.value;
    this.setState({ query });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.load(query), 300);
  };

  onSelect = e => {
    const value = e.target.value;
    const impersonating = Boolean(this.props.decoded.impersonated_by);
    if (!value && !impersonating) return;

    this.setState({ busy: true, error: null });
    new Promise(resolve =>
      this.props.impersonate(value ? Number(value) : null, resolve),
    ).then(errors => {
      const error = errors && Object.values(errors)[0];
      this.setState({ busy: false, error: error || null });
    });
  };

  render() {
        const d = this.props.decoded;
    console.log('[ImpersonationSwitcher] render', {
      hasDecoded: Boolean(d),
      is_staff: d && d.is_staff,
      impersonated_by: d && d.impersonated_by,
      claims: d && Object.keys(d),
    });
    if (!this.isVisible()) return null;

    const { decoded } = this.props;
    const { options, query, busy, error } = this.state;
    const impersonating = Boolean(decoded.impersonated_by);
    // simplejwt's default USER_ID_CLAIM; the business id while impersonating.
    const current = impersonating ? String(decoded.user_id) : '';
    const known = options.some(o => String(o.id) === current);

    return (
      <div
        className={cx('impersonation-switcher', {
          'is-impersonating': impersonating,
        })}
      >
        <span className="impersonation-label">
          {impersonating ? 'Viewing as' : 'Admin'}
        </span>
        <input
          placeholder="Search businesses"
          value={query}
          onChange={this.onSearch}
        />
        <select value={current} disabled={busy} onChange={this.onSelect}>
          <option value="">
            {impersonating ? '— Back to admin —' : '— Select a business —'}
          </option>
          {impersonating && !known && (
            <option value={current}>Business #{current}</option>
          )}
          {options.map(o => (
            <option key={o.id} value={String(o.id)}>
              {o.name} ({o.email})
            </option>
          ))}
        </select>
        {error && <span className="impersonation-error">{error}</span>}
      </div>
    );
  }
}

export default connect(
  state => ({ decoded: state.auth.tokens.accessDecoded }),
  {
    impersonate: actions.impersonate,
    fetchOptions: actions.fetchImpersonationOptions,
  },
)(ImpersonationSwitcher);